export default __webpack_public_path__ + "static/muli-v20-latin-700-55bad2f8b74c80f75f29d13cf875b738.ttf";